import niceSelect from 'jquery-nice-select';
import { hasForms2 } from "../../js/helpers";

(function ($) {

    $(document).ready(() => {

        $('.block.marketo-form').map((index, block) => {
            const form = $(block).find('form');
            const id = form.attr('data-form-id');

            if (hasForms2()) {
                MktoForms2.loadForm("//app-sn03.marketo.com", "091-LWC-058", id);
                MktoForms2.whenReady(function (){
                    form.removeClass('loading');
                    //form.find('select').niceSelect(); // niceSelect on marketo forms breaks marketo conditional logic
                });
            }

        });
    });

})(jQuery);
